
import Url from 'url-parse';
import path from 'path-browserify';
import AddResourceForm from './add-resource-form.vue';
import ImageUploader from './image-uploader.vue';

export default {
  components: {
    AddResourceForm: AddResourceForm,
    ImageUploader: ImageUploader
  },

  props: {
    closeAddLocalResourceInZipDialog: Function,
    updateCurrentCategory: Function,
    updateCurrentResource: Function,
    updateCurrentResourceInZip: Function,
    currentCategory: Object,
    currentResource: Object,
    currentResourceInZip: Object,
    addLocalResourceInZipDialog: Object,
    updateResource: Function,
    previewImage: Function
  },

  data: function data() {
    return {
      model: {
        file: ''
      },
      fileList: [],
      uploading: false
    };
  },


  computed: {
    dialog: function dialog() {
      if (!this.currentResourceInZip) return {};

      return {
        title: this.$t('playTurbo.creative.localResourceInZipDialog.title') + ' ' + (this.currentResourceInZip.name || ''),
        class: 'add-local-resource-in-zip-dialog',
        width: '600px'
      };
    },
    submitButton: function submitButton() {
      return {
        loading: this.uploading,
        disabled: !this.model.file
      };
    },
    uploader: function uploader() {
      var _this = this;

      if (!this.currentResourceInZip) return {};

      // 重命名，保证文件名字与 zip 包中原始名字一致，因为 playable 的资源是不可被重命名的
      var data = {};
      if (this.currentResourceInZip) {
        data.rename = this.currentResourceInZip.name;
      }

      var fileExtension = path.parse(this.currentResourceInZip.url).ext.replace('.', '');

      var getTip = function getTip() {
        var tip = _this.$t('playTurbo.creative.localResourceInZipDialog.tips') + ' ' + fileExtension.toUpperCase();

        if (_this.currentResourceInZip.width && _this.currentResourceInZip.height) {
          tip += '\uFF1B' + _this.$t('playTurbo.creative.localResourceInZipDialog.rules') + ' ' + _this.currentResourceInZip.width + '*' + _this.currentResourceInZip.height + '\uFF1B';
        }

        return tip;
      };

      return {
        data: data,
        accept: '.' + fileExtension,
        tip: getTip()
      };
    }
  },

  methods: {
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var _this2 = this;

      var file = _ref.file;

      var newResource = {
        preview_urls: this.currentResource.preview_urls.map(function (item, index) {
          if (_this2.currentResourceInZip.index === index) {
            return file.url;
          }
          return item;
        }),
        prefix: this.currentCategory.prefix,
        id: this.currentResource.id,
        resource_type: this.currentCategory.resource_type,
        category_id: this.currentCategory.id
      };
      this.updateResource(newResource);
      this.close();

      // zip 包单图实时预览
      var targetResource = this.currentResource.preview_urls[this.currentResourceInZip.index];
      this.previewImage({
        path: new Url(targetResource).pathname,
        url: file.url
      });
    },
    submit: function submit() {},
    close: function close() {
      this.closeAddLocalResourceInZipDialog();
      this.updateCurrentCategory(null);
      this.updateCurrentResource(null);
      this.updateCurrentResourceInZip(null);
    },
    updateUploading: function updateUploading(val) {
      this.uploading = val;
    }
  }
};